function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import cn from 'classnames';
import styles from "./Divider.module.scss";
const getInlineMarginByOrientation = _ref => {
  let {
    margin,
    orientation
  } = _ref;
  return {
    style: {
      margin: orientation === 'horizontal' ? "".concat(margin, "px 0 ").concat(margin, "px 0") : "0 ".concat(margin, "px 0 ").concat(margin, "px")
    }
  };
};
export const Divider = _ref2 => {
  let {
    skin = 'default',
    margin = 24,
    orientation = 'horizontal',
    className
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cn(styles[skin], styles[orientation], className)
  }, getInlineMarginByOrientation({
    margin,
    orientation
  })));
};